import * as React from 'react';
import { Cell } from './Cell';

export const EmptyCell: React.FC = () => {
  return <Cell className="flex text-center justify-center">-</Cell>;
};
EmptyCell.displayName = 'ContainerTable.EmptyCell';
